/*eslint-disable*/
import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import Axios from 'axios';

import APP_CONSTANTS from '../../config/constants';



const BankDropdown = ({
        field: { name },
        form: { setFieldValue },
        ...props
    }) => {
        
        const [bank, setBank] = useState([])
        const [isLoading, setIsLoading] = useState(false)

        useEffect(() => {
            setIsLoading(true)
            let token = localStorage.getItem('apiToken')
            let userId = localStorage.getItem('userId')
            let customerNo = localStorage.getItem('customerNo')
            let data = JSON.stringify
                ({
                    "customerNumber": customerNo,
                    "userId": userId,
                    "customer_no": customerNo,
                    "user_id": userId,
                    "customerNo": customerNo
                })

            Axios.get(`${APP_CONSTANTS.BASE_URL}masters/bank/?customerNumber=${customerNo}&userId=${userId}`, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).then((response => {
                setBank(response.data.resultSet)
                setIsLoading(false)
            }))
                .catch(error => console.log(error))
                setIsLoading(false)
        }, [])
        

        let options = []
        if (bank && bank.length > 0) {
            bank.map((object, index) => {
                let temp = {}
                temp.key = object.bankId
                temp.text = object.bankName
                temp.value = object.bankCode
                return options[index] = temp
            })
        }

    return (
        <Dropdown
            selection
            onChange={(value, data) => setFieldValue(name, data.value)}
            options={options}
            clearable
            loading={isLoading}
            {...props}
            fluid
        />

    )
}

export default BankDropdown